import { Base } from '@studiometa/js-toolkit';
import DualRangeInput from '@stanko/dual-range-input';

/**
 * PriceRange class.
 */
export default class PriceRange extends Base {
  static config = {
    name: 'PriceRange',
    refs: ['min', 'max', 'values'],
  };

  /**
   * Mounted.
   */
  mounted() {
    this.priceInput();
  }

  /**
   *
   */
  addValues() {
    this.$refs.values.innerHTML = `
    <span>${this.$refs.min.min}</span>
    <span>${this.$refs.min.value} - ${this.$refs.max.value}</span>
    <span>${this.$refs.max.max}</span>`;
  }

  /**
   *
   */
  priceInput() {
    new DualRangeInput(this.$refs.min, this.$refs.max);
    this.addValues();
  }

  /**
   *
   */
  onMaxInput() {
    this.addValues();
  }

  /**
   *
   */
  onMinInput() {
    this.addValues();
  }
}
